import { Link } from "react-router";
import { useT } from "../../lib/use-t";

/**
 * Shown when an admin route 403s the current user. The route still
 * renders (it's gated by AppLayout's session check, not a client-side
 * role check) — this panel replaces the page content so unauthorised
 * users get a clear bounce-back rather than a stuck spinner.
 */
export function ForbiddenPanel() {
  const t = useT();
  return (
    <div className="space-y-4">
      <p className="font-mono-badge text-xs uppercase tracking-wider text-[var(--ink-faint)]">
        {t("admin.forbidden.eyebrow")}
      </p>
      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">
        {t("admin.forbidden.title")}
      </h1>
      <p className="text-sm text-[var(--ink-muted)] font-serif-italic max-w-prose">
        {t("admin.forbidden.description")}
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
      >
        <span aria-hidden>←</span>
        <span>{t("admin.forbidden.backToHome")}</span>
      </Link>
    </div>
  );
}
